import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotOnboarded = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={228}
    height={219}
    viewBox="0 0 228 219"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <ellipse cx={116} cy={98.449} rx={98} ry={97.449} fill="#E8EEFF" />
    <g filter="url(#not-onboarded_svg__a)">
      <path d="M64 60a2 2 0 0 1 2-2h96a2 2 0 0 1 2 2v69a2 2 0 0 1-2 2H66a2 2 0 0 1-2-2V60Z" fill="#E8ECEE" />
      <rect x={67} y={61} width={94} height={9} rx={1} fill="#174174" />
      <rect x={67} y={73} width={59} height={55} rx={1} fill="#fff" />
      <rect x={70.785} y={93.388} width={38.02} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={71} y={99} width={48} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={69.959} y={82.816} width={24.796} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={70.785} y={104.959} width={29.755} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={69.96} y={77.031} width={33.061} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={70.785} y={121.49} width={37.194} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={70.785} y={115.704} width={20.663} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={129} y={73} width={32} height={55} rx={1} fill="#fff" />
      <rect x={132} y={77} width={23.143} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={132} y={93} width={16} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={131.602} y={115.704} width={19.837} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={131.602} y={82.816} width={14.051} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={131.602} y={99.174} width={21.49} height={2.5} rx={1.25} fill="#DCE1E4" />
      <rect x={131.602} y={121.49} width={16.531} height={2.5} rx={1.25} fill="#DCE1E4" />
    </g>
    <circle cx={153.603} cy={123.25} r={16.25} fill="#184F81" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.5 114.5c-2.047 0-3.706 1.535-3.706 3.429 0 1.893 1.659 3.428 3.706 3.428 2.047 0 3.706-1.535 3.706-3.428 0-1.894-1.659-3.429-3.706-3.429Zm0 8.381a7.072 7.072 0 0 0-4.95 2.01 6.797 6.797 0 0 0-2.05 4.854c0 .2.081.392.226.534.144.141.34.221.544.221h12.46c.204 0 .4-.08.544-.221a.747.747 0 0 0 .226-.534 6.797 6.797 0 0 0-2.05-4.854 7.072 7.072 0 0 0-4.95-2.01Z"
      fill="#fff"
    />
    <defs>
      <filter
        id="not-onboarded_svg__a"
        x={0}
        y={18}
        width={228}
        height={201}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2795_219140" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={8} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_2795_219140" result="effect2_dropShadow_2795_219140" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={16} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect2_dropShadow_2795_219140" result="effect3_dropShadow_2795_219140" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={32} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_2795_219140" result="effect4_dropShadow_2795_219140" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_2795_219140" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default SvgNotOnboarded;
